import { maxLength, maxValue, minValue, required } from 'react-admin';
import { Box } from 'shared/mui/Box';
import { WhiteIpAddressesTooltip } from 'shared/mui/Tooltip/WhiteIpAddressesTooltip/WhiteIpAddressesTooltip';
import { IpAddressInput, NumberInput, TextInput } from 'shared/react-admin/Inputs';

import { CardContentStyled } from './ApiClientsShowWhiteIpAddressesForm.styled';

export const ApiClientsShowWhiteIpAddressesForm = () => {
  return (
    <CardContentStyled>
      <IpAddressInput
        label="IP адрес"
        size="small"
        source="ip"
        validate={required()}
        variant="outlined"
      />
      <Box display="flex" gap="12px">
        <NumberInput
          defaultValue={32}
          label="Маска"
          size="small"
          slotProps={{
            inputLabel: { shrink: true },
          }}
          source="mask"
          validate={[minValue(0), maxValue(32)]}
          variant="outlined"
        />
        <WhiteIpAddressesTooltip sx={{ marginTop: '10px' }} />
      </Box>
      <TextInput
        label="Комментарий"
        multiline
        parse={(v: string) => (v ? v : '')}
        size="small"
        source="comment"
        validate={maxLength(
          255,
          'Это значение слишком длинное. Оно должно содержать 255 символа или меньше.',
        )}
        variant="outlined"
      />
    </CardContentStyled>
  );
};
